import { useState } from "react";
import { faqs } from "@/mocks/suye";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="border-b border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[880px] px-4 md:px-6">
        <SectionHeading
          kicker="常见问题"
          title={
            <>
              关于宿野，<span className="text-primary-600">你想知道的</span>
            </>
          }
          desc="在开吃之前，先把规则和原则说清楚，大家才吃得放心。"
        />
        <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div key={f.q} className={isOpen ? "bg-background-100/40" : "bg-background-50"}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                >
                  <span className="flex items-center gap-3 font-medium text-foreground-950">
                    <span
                      className={
                        "flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-xs font-bold " +
                        (isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600")
                      }
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={
                      "ri-add-line shrink-0 text-lg transition-transform duration-300 " +
                      (isOpen ? "rotate-45 text-primary-600" : "text-foreground-500")
                    }
                  />
                </button>
                <div
                  className={
                    "grid transition-all duration-300 " + (isOpen ? "grid-rows-[1fr] pb-5" : "grid-rows-[0fr]")
                  }
                >
                  <div className="overflow-hidden px-5 pl-[52px] md:px-6 md:pl-16">
                    <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}